export const NEW = "NEW";
export const DAY = "DAY";
export const NIGHT = "NIGHT";
